import React from "react";
import OfficeToPdfConverter from "../../components/OfficeToPdfConverter";

const Word2Pdf = () => (
  <OfficeToPdfConverter
    documentLabel="Word"
    title={
      <>
        Convert <b>WORD</b> documents to <b>PDF</b>.
      </>
    }
    description="Make your DOC and DOCX files more accessible by converting them to PDF."
    accept=".doc,.docx"
    emptyMessage="Please select one or more DOC or DOCX files."
  />
);

export default Word2Pdf;
